import * as React from "react"
import { Link } from "gatsby"

const BlogRelated = ({posts, event}) => {

  return (
    <div className="mt-10 lg:mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
    {posts.map((post,index) => {
        const title = post.frontmatter.title
        const url = post.frontmatter.url
        const img = post.frontmatter.image
        const lastmod = post.frontmatter.lastmod

        return (
          <article key={index}>
            <Link className={event} to={`/${url}`}>
              <div className="relative">
                <img className="border border-slate-200 object-cover h-[150px] w-full rounded-lg" src={img} alt={title} loading="lazy" />
              </div>
              <h3 className="mt-[20px] font-bold text-lg">
                <span>{title}</span>
              </h3>
              <p className="flex items-center mt-3 md:text-xs">
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5988 0C3.0939 0 0.242432 2.6916 0.242432 6C0.242432 9.3084 3.0939 12 6.5988 12C10.1037 12 12.9552 9.3084 12.9552 6C12.9552 2.6916 10.1037 0 6.5988 0ZM6.5988 10.8C3.795 10.8 1.5137 8.6466 1.5137 6C1.5137 3.3534 3.795 1.2 6.5988 1.2C9.40259 1.2 11.6839 3.3534 11.6839 6C11.6839 8.6466 9.40259 10.8 6.5988 10.8Z" fill="#999999"/><path d="M7.23441 3H5.96313V6.2484L8.05629 8.2242L8.95508 7.3758L7.23441 5.7516V3Z" fill="#999999"/></svg>
                <span className="ml-[5px] text-gray-500">{lastmod}</span>
              </p>
            </Link>
          </article>
        )
      })}
    </div>
  )
}

export default BlogRelated